'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    largeTitleClassNames: function() {
        return largeTitleClassNames;
    },
    useLargeTitleStyles: function() {
        return useLargeTitleStyles;
    }
});
const _react = require("@griffel/react");
const largeTitleClassNames = {
    root: 'fui-LargeTitle'
};
const useLargeTitleStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f15afnhw",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fr3w3wp"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f15afnhw{font-size:var(--fontSizeHero900);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fr3w3wp{line-height:var(--lineHeightHero900);}"
    ]
});
